<template>
  <div class="invoice-statement-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Financeiro &raquo; Extrato de transações</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
<!--              <b-col cols="auto">-->
<!--                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/financeiro/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>-->
<!--              </b-col>-->
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col cols="12" lg="4">
              <label class="cj-label">Período</label>
              <date-range-picker
                  class="w-100"
                  ref="picker"
                  :localeData="dateRangePickerPtBrLocale"
                  :timePicker="false"
                  :timePicker24Hour="false"
                  :showDropdowns="true"
                  :ranges="false"
                  :showWeekNumbers="false"
                  :opens="'right'"
                  v-model="invoiceStatementFilterForm.dateTime">
                <div slot="input" slot-scope="picker" class="">
                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
                </div>
              </date-range-picker>
            </b-col>
            <b-col cols="12" lg="5">
              <label class="cj-label">Unidade</label>
              <multiselect v-model="invoiceStatementFilterForm.unit" :options="units" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Selecione"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getInvoiceStatements()"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <p class="title">Extrato de transações</p>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Cliente</th>
                      <th>Descrição</th>
                      <th>Método de pagamento</th>
                      <th>Identificador</th>
                      <th>Valor</th>
                      <th>Tarifa</th>
                      <th>Valor final</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="statement in invoiceStatements">
                      <tr class="transfer-entry" :key="statement.id">
                        <td>{{ moment(statement.date).format('DD/MM/YYYY') }}</td>
                        <td colspan="3">Transferência para {{ statement.bank_name + ' - Ag: ' + statement.bank_routing_number + ' Conta: ' + statement.bank_account + (statement.status == 'pending' ? ' (Pendente)' : '') }}</td>
                        <td>{{ statement.transfer_number }}</td>
                        <td>R$ {{ formatPrice(statement.transactions.reduce((total, item) => total + parseFloat(item.amount), 0)) }}</td>
                        <td>R$ {{ formatPrice(statement.transactions.reduce((total, item) => total + parseFloat(item.fees), 0)) }}</td>
                        <td>R$ {{ formatPrice(statement.amount) }}</td>
                      </tr>
                      <tr class="transaction-entry" v-for="transaction in statement.transactions" :key="transaction.id">
                        <td>{{ moment(transaction.date).format('DD/MM/YYYY HH:mm') }}</td>
                        <td>{{invoices[transaction.id] && invoices[transaction.id].payer != null ? invoices[transaction.id].payer : '-'}}</td>
                        <td>
                          <template v-if="invoices[transaction.id]">
                            <router-link v-if="invoices[transaction.id].transaction_description != null" tag="a" :to="'/financeiro/contas-a-receber/'+invoices[transaction.id].transaction_id">
                              {{invoices[transaction.id].transaction_description}}
                            </router-link>
                            <template v-if="invoices[transaction.id].transaction_description != null && invoices[transaction.id].appointment_id != null"> - </template>
                          </template>
                          <template v-else>-</template>
                        </td>

                        <td>{{ transaction.payment_type == 'boleto' ? 'Boleto' : (transaction.payment_type == 'pix' ? 'Pix' : ('Crédito ' + transaction.payment_method.card_brand + ' ' + transaction.payment_method.first4_digits + ' ****')) }}</td>

                        <td>
                          <template v-if="invoices[transaction.id]">
                            {{ transaction.payment_type == 'boleto' ? invoices[transaction.id].boleto_document_number : (invoices[transaction.id].payment_method == 'Pix' ? invoices[transaction.id].pix_id : (invoices[transaction.id].card_nsu != null ? (invoices[transaction.id].card_nsu + '-' + invoices[transaction.id].card_auth) : '')) }}
                          </template>
                          <template v-else>-</template>
                        </td>
                        <td>R$ {{ formatPrice(transaction.amount) }}</td>
                        <td>R$ {{ formatPrice(transaction.fees) }}</td>
                        <td>R$ {{ formatPrice(transaction.amount - transaction.fees) }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <p v-if="invoiceStatements.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'transação',
        termPlural: 'transações',
        url: 'transacoes',
        letter: 'a',
        newTerm: 'cadastrar-transacao',
        module: 'units',


        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,

        invoiceStatements: [],
        invoices: [],

        units: [],

        invoiceStatementFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          status: null,
          unit: null,
          zoopId: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      await this.api.getUnits({status: 'enabled', all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.eventBus.$emit('IS_LOADING', false);
        this.units = [];
        res.data.forEach(unit => {
          this.units.push({value: unit.id, name: unit.display_name});
        });
        if(this.units.length > 0) {
          this.invoiceStatementFilterForm.unit = this.units[0];
          this.getInvoiceStatements();
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Units', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as unidades com meio de pagamento integrado da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Units', err.response);
      });
    },
    methods: {
      getInvoiceStatements() {
        if(this.invoiceStatementFilterForm.unit == null) {
          this.$swal('Ops...', 'Por favor, selecione uma unidade para a busca.', 'warning');
          return;
        }
        if(this.moment(this.invoiceStatementFilterForm.dateTime.endDate).diff(this.moment(this.invoiceStatementFilterForm.dateTime.startDate), 'days', true) > 60) {
          this.$swal('Ops...', 'Por favor, selecione um período de até 60 dias.', 'warning');
          return;
        }
        this.eventBus.$emit('IS_LOADING', true);
        let invoiceStatementFilterData = {
          start_date: this.moment(this.invoiceStatementFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.invoiceStatementFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          unit_id: this.invoiceStatementFilterForm.unit.value,
        };

        this.api.getInvoiceStatements(invoiceStatementFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.invoiceStatements = res.data.transfers;
          this.invoices = res.data.invoices;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Invoices Statements', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos carregar o extrato de transações da sua clínica! Por favor, entre em contato com o suporte!';
          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Invoices Statements', err.response);
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      // getPaymentMethodName(paymentMethod) {
      //   if(paymentMethod == 'credit') {
      //     return 'Cartão de Crédito';
      //   }
      //   if(paymentMethod == 'debit') {
      //     return 'Cartão de Débito';
      //   }
      //   if(paymentMethod == 'boleto') {
      //     return 'Boleto';
      //   }
      //   if(paymentMethod == 'boleto') {
      //     return 'Boleto';
      //   }
      //   return 'pix';
      // }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .invoice-statement-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }

          td {
            font-size: 14px;
          }
        }
      }

      .table {
        .transfer-entry {
          background-color: #eee!important;

          td {
            font-family: 'sf_pro_displaybold';
          }
          //.bg-success {
          //  border-top-color: #28a745;
          //}
          //.bg-danger {
          //  border-top-color: #dc3545;
          //}
        }
        .transaction-entry {
          background-color: #fff!important;
          //font-family: 'sf_pro_displayregular';
          //
          //.text-success,
          //.text-danger {
          //  font-family: 'sf_pro_displaysemibold';
          //}
        }
      }
    }
  }
</style>
